"use client"

import SignupModal, { SignupModalRef } from "@/components/authen/signup/SignupModal"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useIsAuthen } from "@/hooks/auth/useIsAuthen"
import { Button, Image, Modal } from "antd"
import { useRouter } from "next/navigation"
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react"
import ModalContactNow, { ModalContactNowRef } from "@/components/flight/flights/components/PromotionVietjet/ModalContactNow"
import { useTERouter } from "@/hooks/app/useTERouter"
import ModalCharter, { ModalCharterRef } from "@/components/common/ModalCharter"
import { CampaignBanner } from "@/lib/redux/features/flight/type"

export type PopupModalRef = {
  close: () => void,
  open: (src?: string, redirect?: string) => void
}

type PopupModalProps = {
  data: CampaignBanner[]
}

const PopupModal = forwardRef<PopupModalRef, PopupModalProps>(({ data }, ref) => {
  const isAuthen = useIsAuthen()
  const isDesktop = useIsDesktop()
  const router = useTERouter()
  const [open, setOpen] = useState<boolean>(false)
  const [redirect, setRedirect] = useState<string | null>(null)
  const [img, setImg] = useState<string | null>(null)
  const refSignupModal = useRef<SignupModalRef>(null)
  const refModalContactNow = useRef<ModalContactNowRef>(null)
  const handleClose = useCallback(() => setOpen(false), [])
  const refModalCharter = useRef<ModalCharterRef>(null)
  const [currentIndex, setCurrentIndex] = useState<number>(0)

  const validPopups = data.map((campaign, idx) => ({
    alt: campaign.displayName,
    url: campaign.subPopup[0].url,
    redirectUrl: campaign.redirectUrl,
    duration: campaign.duration,
    onClick: () => {
      handleClose()
      setTimeout(() => {
        if (campaign.displayName === 'VE_BAY_TET_2026_DONG_GIA') {
          refModalCharter.current?.open()
          return
        } else if (idx < (validPopups.length - 1)) {
          setCurrentIndex(idx + 1)
          handleOpen()
        }
      }, 400)
    },
  }))
    .filter(campaign => !!campaign.url)

  const handleGoNow = useCallback((e: React.MouseEvent, url: string) => {
    e.stopPropagation()
    handleClose()
    if (/^https?:\/\//i.test(url)) {
      window.location.href = url
    } else {
      router.push(url)
    }
  }, [handleClose, router])

  const handleOpen = useCallback((src?: string, redirect?: string) => {
    setOpen(true)
    setRedirect(redirect || (isAuthen ? "/khuyen-mai" : "/sign-up"))
    setImg(src || "/static/images/new_user_deals/popup/ve-may-bay-tet-2026.png")
  }, [isAuthen])

  useEffect(() => {
    setOpen(true)
  }, [])

  const currentDuration = validPopups[currentIndex]?.duration

  useEffect(() => {
    if (!open || currentDuration == null) return

    const timer = setTimeout(() => {
      setOpen(false)
    }, currentDuration * 1000)

    return () => clearTimeout(timer)
  }, [open, currentIndex, currentDuration])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  return (
    <Modal
      open={open && validPopups.length > 0}
      onCancel={handleClose}
      footer={<></>}
      // closable={false}
      className="popup_newuser_deals"
      styles={{
        container: {
          padding: 0,
          background: 'none',
          boxShadow: 'none'
        },
      }}
      centered
      width={isDesktop ? '48rem' : 'calc(100vw - 3.2rem)'}
    >
      <SignupModal ref={refSignupModal} />
      <ModalContactNow ref={refModalContactNow} />
      <ModalCharter ref={refModalCharter} />
      {validPopups.length > 0 && (
        <div style={{ position: 'relative', width: 'fit-content', maxWidth: '100%', margin: '0 auto' }}>
          <Image
            onClick={validPopups[currentIndex].onClick}
            style={{ borderRadius: 8, display: 'block', width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '85vh' }}
            preview={false}
            src={validPopups[currentIndex].url}
          />
          {validPopups[currentIndex].redirectUrl && (
            <Button
              type="primary"
              className="popup_newuser_deals__cta"
              style={{
                position: 'absolute',
                left: '50%',
                bottom: '4%',
                transform: 'translateX(-50%)',
                height: 'auto',
                padding: '0.5em 1.43em',
                fontSize: 'clamp(1.21rem, 3.3vw, 2.09rem)',
                fontWeight: 600,
                borderRadius: 999,
                backgroundColor: '#1F8FE8',
                border: '0.15em solid #ffffff',
                color: '#ffffff',
                boxShadow: '0 0.2em 0.4em rgba(31, 143, 232, 0.5)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#3FA4EE'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#1F8FE8'
              }}
              onClick={(e) => handleGoNow(e, validPopups[currentIndex].redirectUrl as string)}
            >
              Đến xem ngay
            </Button>
          )}
        </div>
      )}
    </Modal>
  )
})

export default PopupModal